import useUser from '@vl-core/hooks/useUser';

export function useIsAuditReferrer() {
  const user = useUser();
  const userType = user.user_type_code;
  const userRole = user.user_role_code;

  return userType === 'REFERRER' && userRole === 'AUDIT';
}

export default useIsAuditReferrer;
